
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"41","height":"41"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1935","fill":"none","stroke":"#ee1d23","stroke-width":"4"}},[_c('g',[_c('circle',{attrs:{"cx":"20.5","cy":"20.5","r":"20.5","stroke":"none"}}),_c('circle',{attrs:{"cx":"20.5","cy":"20.5","r":"18.5"}})]),_c('path',{attrs:{"data-name":"선 725","d":"M20.5 0v41"}}),_c('path',{attrs:{"data-name":"선 726","d":"M34.996 34.996L20.5 20.5"}})])])
          )
        }
      }
    